import {MixModel, ModerationStatus} from '../../api/types.ts';

const emptyMix: MixModel = {
    id: null,
    name: '',
    description: '',
    tags: [],
    customUrl: '',
    rank: null,
    rankOverride: null,
    revision: 0,
    userId: null,
    nickname: '',
    userName: '',
    userThumbnail: '',
    userContainerName: '',
    thumbnail: '',
    thumbnailHasChanged: false,
    content: {
        id: null,
        sections: []
    },
    moderationStatus: ModerationStatus.Accepted,
    moderationMessage: '',
    blocked: false,
    archived: false,
    templateId: null,
    isTemplate: false,
    createdFromTemplateId: null,
    collections: [],
    editors: [],
    tabs: null
};

export default emptyMix;
